<template>
  <div class="outDiv">
    <div class="searchBar">
      <div class="searchLeft">
        <el-popover
          placement="right-bottom"
          title="条件检索"
          trigger="click"
          v-model="searchVisible"
        >
          <searchForm
            @startSearch="handleTableSearch"
            @cancleSearch="handleCancleSeach"
          ></searchForm>
          <el-button slot="reference" size="mini">按条件筛选</el-button>
        </el-popover>
        <navTopTag
          :searchTagList="searchTagList"
          @handleDelOne="handleDelOne"
        ></navTopTag>
      </div>
    </div>
    <div>
      <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
        <el-tab-pane
          label="所有记录"
          name="all"
          ref="all"
          id="allTab"
        ></el-tab-pane>
        <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
      </el-tabs>
      <div class="tableContainer">
        <baseTable
          :columns="allTableObj.columns"
          :dataList="allTableObj.dataList"
          :options="allTableObj.options"
          :loadObj="allTableObj.loadObj"
          :operationColumn="allTableObj.operationColumn"
          :fenyeObj="allTableObj.fenyeObj"
          @dataSizeChange="handleSizeChange($event, allTableObj)"
          @dataCurrentChange="handleCurrentChange($event, allTableObj)"
        ></baseTable>
      </div>
    </div>
  </div>
</template>
<script>
import { alarmorderApi } from "@/services/all-api.js"
import searchForm from "./search-form.vue";
import { mapState } from "vuex";
export default {
  components: {
    searchForm
  },
  computed: {
    ...mapState(["currentSearchForm"])
  },
  data() {
    return {
      searchVisible: false,
      searchTagList: [],
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "50px",
            align: "center"
          },
          {
            prop: "number",
            label: "工单编号",
            align: "center",
            route: true,
          },
          {
            prop: "create_time",
            label: "工单生成时间",
            align: "center",
            render: (h, params) => {
              return h("span", null, this.Utils.dateFormat(params.row.create_time, "YYYY-MM-DD HH:mm:ss"))
            }
          },
          {
            prop: "user_name",
            label: "服务对象",
            align: "center",
          },
          {
            prop: "type",
            label: "工单类型",
            align: "center",
            render: (h, params) => {
              let str = this.getNameOfWorkorderType(params.row.type);
              return h("span", null, str)
            }
          },
          {
            prop: "time",
            label: "受理时长",
            align: "center"
          },
          {
            prop: "status",
            label: "状态",
            align: "center",
            render: (h, params) => {
              let str = this.getNameOfWorkorderStatus(params.row.status);
              return h("span", null, str)
            }
          },
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead
        },
        loadObj: {
          isLoading: false
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "150px",
          btns: [
            {
              size: "mini",
              text: "详情",
              type: "text",
              style: "font-size:14px",
              disabled: false,
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            }
          ],
          otherBtn: [
            {
              item: "status",
              value: ['0', '1'],
              size: "mini",
              text: "受理",
              type: "text",
              style: "font-size:14px",
              disabled: false,
              method: (index, row) => {
                this.handleAccept(index, row);
              }
            }
          ]
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0
        },
        currentTab: "all",
        searchObj: {}
      }
    }
  },
  methods: {
    loadData(obj) {
      obj.loadObj.isLoading = true;
      alarmorderApi.getList({
        size: obj.allDataNow.pageSize,
        index: obj.allDataNow.currentPage - 1
      }).then(result => {
        let list = result.data.data || []
        //先缓存
        _.forEach(list, (item, idx) => {
          item.num = result.data.index * result.data.size + idx + 1
          item.create_time = item.create_time && item.create_time.$date
          if (item.finish_time && item.finish_time.$date) {
            item.finish_time = item.finish_time && item.finish_time.$date
            let t = item.finish_time - item.create_time
            if (t) {
              item.time = this.Utils.formatTime(t)
            }
          }
        })
        obj.allDataNow.dataList = list;
        obj.allDataNow.total = result.data.total;
        //最后赋值  默认全部
        obj.dataList = list;
        obj.fenyeObj.total = result.data.total;
      }).finally(() => {
        obj.loadObj.isLoading = false;
      });
    },
    //每次页面码数变了 要变回第一页
    handleSizeChange(i, obj) {
      let reqObj = {};
      if (obj.currentTab == "all") {
        obj.allDataNow.currentPage = 1;
        obj.allDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i
        };
      } else if (obj.currentTab == "search") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCurrentChange(i, obj) {
      let reqObj = {};
      let flag = obj.currentTab;
      if (flag == "all") {
        obj.allDataNow.currentPage = i;
        obj.allDataNow.pageSize = obj.allDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.allDataNow.pageSize
        };
      } else if (flag == "search") {
        obj.searchDataNow.currentPage = i;
        obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.searchDataNow.pageSize,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleTableSearch(i) {
      this.searchVisible = i.searchShow;
      this.searchTagList = this.getTagList(
        this.getLosscallSearch(),
        i.searchData
      );
      this.$store.commit("setSearchForm", i.searchData);
      this.allTableObj.searchObj = i.searchData;
      this.allTableObj.currentTab = "search";
      const reqObj = {
        index: 0,
        size: 20,
        ...i.searchData
      };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCancleSeach(i) {
      this.searchVisible = i.searchShow;
    },
    handleDelOne(i) {
      //减少一个检索条件时
      this.searchTagList = this.searchTagList.filter((item, index) => {
        if (item[0] === i[0]) {
          return false;
        } else {
          return true;
        }
      });
      const obj = this.deleteOneSearch(
        i[0],
        this.$store.state.currentSearchForm
      );
      if (this.$baseFunc.paramsValidate(obj)) {
        this.allTableObj.searchDataNow.dataList = [];
        this.allTableObj.searchDataNow.currentPage = 1;
        this.allTableObj.searchDataNow.pageSize = 20;
        this.allTableObj.searchDataNow.total = 0;
        this.allTableObj.currentTab = "all";
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      } else {
        const reqObj = {
          index: 0,
          size: 20,
          ...obj
        };
        this.pageSearchGet(reqObj, this.allTableObj);
      }
      this.$store.commit("setSearchForm", obj);
    },
    //检索条件或者分页等变化时请求数据
    pageSearchGet(reqobj, obj) {
      const flag = obj.currentTab;
      obj.loadObj.isLoading = true;
      let endObj = reqobj;
      alarmorderApi.getList(endObj).then(result => {
        let list = result.data.data || []
        _.forEach(list, (item, idx) => {
          item.num = result.data.index * result.data.size + idx + 1
          item.create_time = item.create_time && item.create_time.$date
          if (item.finish_time && item.finish_time.$date) {
            item.finish_time = item.finish_time && item.finish_time.$date
            let t = item.finish_time - item.create_time
            if (t) {
              item.time = this.Utils.formatTime(t)
            }
          }
        })
        if (flag == "all") {
          obj.allDataNow.dataList = list;
          obj.allDataNow.total = result.data.total;
          obj.fenyeObj.currentPage = obj.allDataNow.currentPage;
          obj.fenyeObj.pageSize = obj.allDataNow.pageSize;
          obj.dataList = obj.allDataNow.dataList;
          obj.fenyeObj.total = obj.allDataNow.total;
          return false;
        } else if (flag == "search") {
          obj.searchDataNow.dataList = list;
          obj.searchDataNow.total = result.data.total;
          obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
          obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
          obj.dataList = obj.searchDataNow.dataList;
          obj.fenyeObj.total = obj.searchDataNow.total;
          return false;
        }
      }).finally(() => {
        obj.loadObj.isLoading = false;
      });
    },
    handleDetail(i, j) {
      this.routeTo({ path: '/orders/alarmorder/detail', query: { oid: j._id.$oid } })
    },
    handleAccept(i, j) {
      this.$confirm('确定执行【受理】操作吗？').then(() => {
        alarmorderApi.accept({ id: j._id.$oid }).then(res => {
          if (res.code === 0) {
            this.$message.success('工单受理成功')
            this.routeTo({ path: '/orders/alarmorder/detail', query: { oid: j._id.$oid } })
          } else {
            this.$message.error(`受理失败:${res.des || ""}`);
          }
        }).catch(() => {
        })
      })
    }
  },
  mounted() {
    this.loadData(this.allTableObj);
  }
}
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  display: flex;
  flex-flow: column;
}
.searchBar {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .searchLeft {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
}
.tableContainer > div {
  height: calc(100vh - 410px);
}
</style>